import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Parallax } from 'react-parallax';
import "animate.css/animate.min.css";
import './index.css';

const AboutItem = ({data}) => {
  return (
    <React.Fragment>
        <Parallax
            className="paralax"
            bgImage={require(`../../../image/${data.imgURL}`)}
            strength={100}
        >
        </Parallax>
        <ScrollAnimation animateIn="fadeInUp"
        offset={150} duration={1} 
        initiallyVisible={false} delay={2} animateOnce={true} 
        animatePreScreoll={false} className="about__content">
            <div className="about-content__wrapper">
                <ul className="about-content__tags">
                    {
                        data.tag.map( (tag, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <li className="about-content__tag-gold">{tag}</li>
                                    <li className="about-content__point-gold"></li>
                                </React.Fragment>
                            )
                        })
                    }
                </ul>
                <h3 className="about-content__title">
                    {data.title}
                </h3>
                <p className="about-content__text">
                    {data.text}
                </p>
            </div>
        </ScrollAnimation>
    </React.Fragment>
  );
}

export default AboutItem;
